import React, { useState, useEffect } from 'react';
import API from '../../config/config';

const ProductFeatureWidget = ({ data }: any) => {

  const [state, setstate] = useState({
    active: 0,
    title: data ? data.KeyFeatures[0].title : null,
    description: data ? data.KeyFeatures[0].description : null
  });
  const windowSize = useWindowSize();
  function useWindowSize() {
    const [dimension, setDimensions] = useState({
      height: undefined,
      width: undefined
    });
    useEffect(() => {
      const handleResize = () => {
        setDimensions({
          height: window.innerHeight,
          width: window.innerWidth
        });
      };

      window.addEventListener('resize', handleResize);
      handleResize()
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);
    return dimension
  }
  return (
    data && (
      <div className="container product-key-feature-container">
        <h1 className="title">{data.label}</h1>
        <div className="content-align">
          {windowSize.width > 992 && (
            <div
              className="prod-img"
              style={{ backgroundImage: `url(${data.image ? API.baseUrl + data.image.url : ''})` }}
            >
              {data.KeyFeatures &&
                data.KeyFeatures.map((item: any, i: number) => {
                  return (
                    <div
                      style={{
                        top: item.Positions[0] ? item.Positions[0].top : 0,
                        right: item.Positions[0] ? item.Positions[0].right : 0
                      }}
                      className={'pointer-container ' + (item.Positions[0].alignRight ? 'right' : '')}
                      key={i}
                    >
                      <span className="prod-feature-par ">
                        <span className="prod-feature-sub-par">
                          <span className="prod-feature-keys">{i + 1}</span>
                        </span>
                      </span>
                      <div className={'prod-description ' + (item.Positions[0].alignRight ? 'right' : '')}>
                        <div className="title">{item.title}</div>
                        <div className="description">{item.description}</div>
                      </div>
                    </div>
                  );
                })}
            </div>
          )}
          {windowSize.width <= 992 && (

            <div className="mobile-prod-container">
              <p className="productfeature-p">{data.subTitle}</p>
              <div
                className="prod-img-mobile"
                style={{ backgroundImage: `url(${data.image ? API.baseUrl + data.image.url : ''})` }}
              >
                {data.KeyFeatures.map((item: any, i: number) => {
                  return (
                    <span
                      key={i}
                      className={'prod-feature-par ' + (state.active === i ? 'active' : '')}
                      style={{
                        top: item.Positions[1] ? item.Positions[1].top : 0,
                        right: item.Positions[1] ? item.Positions[1].right : 0
                      }}
                    >
                      <span className="prod-feature-sub-par">
                        <span
                          className="prod-feature-keys "
                          onClick={() => {
                            setstate({
                              active: i,
                              title: item.title,
                              description: item.description
                            });
                          }}
                        >
                          {i + 1}
                        </span>
                      </span>
                    </span>
                  );
                })}
              </div>
              <div className="prod-feature-content">
                <div className="title">{state.title}</div>
                <div className="des">{state.description}</div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  );
};

export default ProductFeatureWidget;
